// extracted by mini-css-extract-plugin
module.exports = {"niceBody":"NotStartedRow_niceBody__1BJnM","tr":"NotStartedRow_tr__2jJLP","pendingLink":"NotStartedRow_pendingLink__1qLqU","actionsRow":"NotStartedRow_actionsRow__24C-7"};